import * as React from "react";
import { forwardRef } from "react";
const SvgChevronsLeft = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 2.25, strokeLinecap: "round", strokeLinejoin: "round", className: "lucide lucide-chevrons-left", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "m11 17-5-5 5-5" }), /* @__PURE__ */ React.createElement("path", { d: "m18 17-5-5 5-5" }));
const ForwardRef = forwardRef(SvgChevronsLeft);
export default ForwardRef;
